import type { ReactNode } from "react";

import {
  Tooltip as PrimitiveTooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../primitive/tooltip";

type TooltipProps = {
  children: ReactNode;
  content: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  sideOffset?: number;
  avoidCollisions?: boolean;
  delayDuration?: number;
  disableHoverableContent?: boolean;
  disabled?: boolean;
};

function Tooltip({
  children,
  content,
  side = "top",
  align = "center",
  sideOffset,
  avoidCollisions = true,
  delayDuration = 0,
  disableHoverableContent = false,
  disabled = false,
}: TooltipProps) {
  if (disabled) {
    return <>{children}</>;
  }

  return (
    <PrimitiveTooltip
      delayDuration={delayDuration}
      disableHoverableContent={disableHoverableContent}
    >
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        side={side}
        align={align}
        sideOffset={sideOffset}
        avoidCollisions={avoidCollisions}
      >
        {content}
      </TooltipContent>
    </PrimitiveTooltip>
  );
}

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
export type { TooltipProps };
